<ng-container *ngIf='authenticatedAndThemeLoaded$ | async; else loader'>
  <router-outlet></router-outlet>
  <div class='row hidden' (click)='toggleVersion()'>
    {{ packageVersion }}
  </div>
</ng-container>

<ng-template #loader><ecmo-loader></ecmo-loader></ng-template>
